<template>
  <el-dialog
    title="合同信息"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="closeDialog">
    <span>合同信息</span>
    <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">取 消</el-button>
    <el-button type="primary" @click="closeDialog">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['dialogVisible'],
  data () {
    return {
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/user/ContractInfo.vue